/**
 * useStockCounters
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import StockCountersContext from './stock-counters-context'

const useStockCounters = () => {
  const context = useContext(StockCountersContext)
  return context
}

export default useStockCounters
